import { getTotalClassLevel } from './classIdentity.mjs';
import { dragonbornAncestryType } from './speciesTraits.mjs';

// 2024 Dragonborn Breath Weapon (SRD 5.2): each use is a 15-foot Cone or a 30-foot Line 5 feet wide, chosen
// when you use it, and the saving throw is always Dexterity. 2014 tied the shape to the ancestry color and gave
// Green, Silver and White a Constitution save; ancestry snapshots saved on characters may still carry those.
export const BREATH_WEAPON_SHAPES = Object.freeze(['15 ft. cone', '30 by 5 ft. line']);
export const BREATH_WEAPON_SAVE = 'Dexterity';
export const BREATH_WEAPON_SHAPE_TEXT = `${BREATH_WEAPON_SHAPES[0]} or ${BREATH_WEAPON_SHAPES[1]}`;

export const BREATH_WEAPON_ID = 'species:breath-weapon';
export const BREATH_WEAPON_USE = 'dragonborn-breath-weapon';
/** 1d10, 2d10 at character level 5, 3d10 at 11, 4d10 at 17. */
export const breathWeaponDice = (character) => {
  const level = getTotalClassLevel(character);
  return level >= 17 ? 4 : level >= 11 ? 3 : level >= 5 ? 2 : 1;
};
/** The area for the chosen shape: a 15-foot Cone or a 30-foot Line 5 feet wide. */
export const breathWeaponTargeting = (shape) => (shape === 'line'
  ? Object.freeze({ shape: 'line', lengthFeet: 30, widthFeet: 5, automated: false })
  : Object.freeze({ shape: 'cone', sizeFeet: 15, automated: false }));
/**
 * Breath Weapon as a save-for-damage source (2024): replaces one attack of the Attack action; each creature in the area
 * makes a Dexterity save (DC 8 + Con modifier + Proficiency Bonus), taking the dice on a failure and half on a success.
 */
export const breathWeaponRules = (character, { constitutionModifier, proficiencyBonus }) => ({
  delivery: 'saving-throw',
  save: { ability: 'dexterity', dc: 8 + Number(constitutionModifier || 0) + Number(proficiencyBonus || 0), successDamageRule: 'half', failureDamageRule: 'full' },
  damage: { components: [{ formula: `${breathWeaponDice(character)}d10`, type: dragonbornAncestryType(character) }] },
});
/** The client's cast definition for map targeting and the save-damage flow. */
export const breathWeaponDefinition = (shape) => ({ id: BREATH_WEAPON_ID, name: 'Breath Weapon', level: 0, delivery: 'saving-throw',
  targeting: breathWeaponTargeting(shape), save: { ability: 'dexterity' } });
